<template>
  <BaseText size="s">
    {{ $t('booking_widget.banner.settings_link') }}
    <BaseText
      size="s"
      :routerLink="{
        name: 'admin-online-bookings'
      }"
      v-test="'booking-widget-settings-link'"
    >
      {{ $t('global.settings') }}> {{ $t('admin.nav.links.online_bookings') }}
    </BaseText>
  </BaseText>
</template>
